import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import AssetsApi from '../../services/api/AssetsApi';
import { ASSET_TOKEN_STATUS, ASSET_TOKEN_TYPE } from '../../types';
import { RootState } from '../../types';
import { showError } from '../../utils/utils';

const setAssetsFetchLoading = createAction<{
  value: boolean;
  name: 'HYBRID' | 'SIMPLE';
}>('asset-details/setAssetsFetchLoading');
const setAssetsDetailsLoading = createAction<{
  value: boolean;
  name: 'details';
}>('asset-details/setLoading');

const getTypeAssets = createAsyncThunk(
  'asset-details/getTypeAssets',
  async (
    payload: {
      type: ASSET_TOKEN_TYPE;
      status: ASSET_TOKEN_STATUS;
      accountId: number;
    },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(
        setAssetsFetchLoading({ value: true, name: payload.type })
      );
      const store = thunkAPI.getState() as RootState;
      const { token } = store.auth.account;
      const response = await AssetsApi.getAssets({
        token,
        ...payload,
        id: payload.accountId,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(
        setAssetsFetchLoading({ value: false, name: payload.type })
      );
    }
    return undefined;
  }
);

const getAssetDetails = createAsyncThunk(
  'asset-details/getDetails',
  async (
    payload: {
      accountId: number;
      tokenId: string;
    },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(
        setAssetsDetailsLoading({ value: true, name: 'details' })
      );
      const store = thunkAPI.getState() as RootState;
      const { token } = store.auth.account;
      const response = await AssetsApi.getDetailedAssetInfo(token, {
        ...payload,
      });
      if (response.status === 200) return response.data;
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(
        setAssetsDetailsLoading({ value: false, name: 'details' })
      );
    }

    return undefined;
  }
);

export { setAssetsDetailsLoading, getAssetDetails, getTypeAssets };
